module.exports = __webpack_public_path__ + "img/check-icon.915f378a.svg";